<template>
  <v-card class="rounded-lg" elevation="0" outlined>
    <v-card-title class="px-2">
      <v-icon left>mdi-wallet</v-icon>
      {{ $lang("mywallet") }}
      <v-spacer></v-spacer>
      <div>
        <div>
          {{ authUser.wallet.vcoin + authUser.wallet.gcoin }}
          {{ $lang("coins") }}
        </div>
        <div class="caption grey--text d-flex">
          <v-spacer></v-spacer>
          *1 {{ $lang("Coin") }}
          =
          {{ $lang("INR", ["1"]) }}
        </div>
      </div>
    </v-card-title>
    <v-divider></v-divider>

    <v-card-actions>
      <v-avatar size="24" class="mr-2" contain>
        <v-img src="/img/coins/coin-single-50.png"></v-img>
      </v-avatar>
      {{ $lang("vCoin") }}
      <v-spacer></v-spacer>
      {{ authUser.wallet.vcoin }}
      {{ $lang("coins") }}
    </v-card-actions>
    <v-divider></v-divider>
    <v-card-actions>
      <v-avatar size="24" class="mr-2" contain>
        <v-img src="/img/coins/coin-single-50.png"></v-img>
      </v-avatar>
      {{ $lang("gCoin") }}
      <v-spacer></v-spacer>
      {{ authUser.wallet.gcoin }}
      {{ $lang("coins") }}
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "my-wallet",
  components: {},

  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      authUser: "auth/user",
    }),

    isHindi() {
      return this.$store.getters.getCurrLocale == "hi";
    },
  },
  watch: {},
  methods: {},
  created() {},
};
</script>
